<form #form="ngForm">
    <div *ngIf="(notificationMailsService.getCurrent() | async) as configSMTP; else loading">

        <!--Carte Configuration-->
        <mat-card>
            <mat-card-title>
                <span [translate]="'admin.bibliotheque.notifications.envoiMails.configuration'"></span>
            </mat-card-title>
            <mat-card-content>
                <div class="row">
                    <!--Type de service-->
                    <custom-input
                            ngDefaultControl
                            customType="select"
                            [(ngModel)]="configSMTP.typeService"
                            [selectOptions]="listeTypeService"
                            libelle="admin.bibliotheque.notifications.envoiMails.service"
                            name="typeService"
                            optionDisplay="libelle"
                            optionValue="type"
                            [disabled]="true">
                    </custom-input>
                    <!--Authentification-->
                    <custom-input
                            *ngIf="configSMTP.typeService === 'SMTP'"
                            ngDefaultControl
                            customType="checkbox"
                            name="authentification"
                            [ngModel]="configSMTP.authentification"
                            [(customModel)]="configSMTP.authentification"
                            libelle="admin.bibliotheque.notifications.envoiMails.authentification"
                            postLibelle="admin.bibliotheque.notifications.envoiMails.activerAuthentification">
                    </custom-input>
                </div>

                <!--Section SMTP-->
                <ng-container *ngIf="configSMTP.typeService === 'SMTP'">
                    <div class="row">
                        <!--Adresse du serveur-->
                        <custom-input
                                ngDefaultControl
                                customType="input"
                                [(ngModel)]="configSMTP.adresse"
                                name="adresse"
                                [lCol]="2"
                                [rCol]="2"
                                [required]="configSMTP.notification"
                                libelle="admin.bibliotheque.notifications.envoiMails.adresse"
                                [postTooltip]="'admin.bibliotheque.notifications.envoiMails.tooltip.adresse' | translate">
                        </custom-input>
                        <!--Port-->
                        <custom-input
                                ngDefaultControl
                                customType="number"
                                [(ngModel)]="configSMTP.port"
                                name="port"
                                [lCol]="1"
                                [rCol]="1"
                                [required]="configSMTP.notification"
                                libelle="admin.bibliotheque.notifications.envoiMails.port"
                                [postTooltip]="'admin.bibliotheque.notifications.envoiMails.tooltip.port' | translate">
                        </custom-input>
                        <!--Identifiant-->
                        <custom-input
                                ngDefaultControl
                                customType="input"
                                [(ngModel)]="configSMTP.identifiant"
                                name="identifiant"
                                [lCol]="2"
                                [rCol]="4"
                                [required]="configSMTP.authentification"
                                libelle="admin.bibliotheque.notifications.envoiMails.identifiant"
                                [disabled]="!configSMTP.authentification">
                        </custom-input>
                    </div>

                    <div class="row">
                        <!--Chiffrement-->
                        <custom-input
                                ngDefaultControl
                                customType="select"
                                [(ngModel)]="configSMTP.typeCryptage"
                                [selectOptions]="listeTypeCryptage"
                                libelle="admin.bibliotheque.notifications.envoiMails.chiffrement"
                                name="typeCryptage"
                                optionDisplay="libelle"
                                optionValue="type"
                                [postTooltip]="'admin.bibliotheque.notifications.envoiMails.tooltip.chiffrement' | translate">
                        </custom-input>
                        <!--Mot de passe-->
                        <custom-input
                                ngDefaultControl
                                customType="input"
                                [isPassword]="true"
                                [(ngModel)]="configSMTP.motDePasse"
                                name="motDePasse"
                                [required]="configSMTP.authentification"
                                libelle="admin.bibliotheque.notifications.envoiMails.motDePasse"
                                [disabled]="!configSMTP.authentification">
                        </custom-input>
                    </div>
                </ng-container>

                <!--Section API-->
                <ng-container *ngIf="configSMTP.typeService === 'API'">
                    <div class="row">
                        <!--Identifiant API-->
                        <custom-input
                                ngDefaultControl
                                customType="input"
                                [(ngModel)]="configSMTP.apiKeyId"
                                name="apiKeyId"
                                libelle="admin.bibliotheque.notifications.envoiMails.identifiant"
                                [postTooltip]="'admin.bibliotheque.notifications.envoiMails.tooltip.identifiantApi' | translate">
                        </custom-input>
                        <!--Clé API-->
                        <custom-input
                                ngDefaultControl
                                customType="input"
                                [isPassword]="true"
                                [(ngModel)]="configSMTP.apiKey"
                                name="apiKey"
                                libelle="admin.bibliotheque.notifications.envoiMails.cleApi"
                                [postTooltip]="'admin.bibliotheque.notifications.envoiMails.tooltip.cleApi' | translate"
                                browserAutocomplete="new-password">
                        </custom-input>
                    </div>
                </ng-container>
            </mat-card-content>
        </mat-card>

        <!--Carte E-mails-->
        <mat-card>
            <mat-card-title>
                <span [translate]="'admin.bibliotheque.notifications.envoiMails.emails'"></span>
            </mat-card-title>
            <mat-card-content>
                <div class="row">
                    <!--Notifications par mail-->
                    <custom-input
                            ngDefaultControl
                            customType="checkbox"
                            name="notification"
                            [ngModel]="configSMTP.notification"
                            [(customModel)]="configSMTP.notification"
                            libelle="admin.bibliotheque.notifications.envoiMails.notifications"
                            postLibelle="admin.bibliotheque.notifications.envoiMails.activerNotifications">
                    </custom-input>
                    <!--Présélection des destinataires-->
                    <custom-input
                            ngDefaultControl
                            customType="checkbox"
                            name="preselectionDestinataire"
                            [ngModel]="configSMTP.preselectionDestinataire"
                            [(customModel)]="configSMTP.preselectionDestinataire"
                            libelle="admin.bibliotheque.notifications.envoiMails.destinataires"
                            postLibelle="admin.bibliotheque.notifications.envoiMails.preselectionDestinataires">
                    </custom-input>
                </div>
                <div class="row">
                    <!--E-mail émetteur-->
                    <custom-input
                            ngDefaultControl
                            customType="input"
                            [(ngModel)]="configSMTP.mailEmetteur"
                            name="mailEmetteur"
                            [required]="configSMTP.notification"
                            libelle="admin.bibliotheque.notifications.envoiMails.mailEmetteur"
                            [postTooltip]="'admin.bibliotheque.notifications.envoiMails.tooltip.mailEmetteur' | translate">
                    </custom-input>
                    <!--E-mail administrateur-->
                    <custom-input
                            ngDefaultControl
                            customType="input"
                            [(ngModel)]="configSMTP.mailAdmin"
                            name="mailAdmin"
                            libelle="admin.bibliotheque.notifications.envoiMails.mailAdmin"
                            [postTooltip]="'admin.bibliotheque.notifications.envoiMails.tooltip.mailAdmin' | translate">
                    </custom-input>
                </div>
                <div class="row">
                    <!--E-mail de réponse-->
                    <custom-input
                            ngDefaultControl
                            customType="input"
                            [(ngModel)]="configSMTP.mailReplyTo"
                            name="mailReplyTo"
                            libelle="admin.bibliotheque.notifications.envoiMails.mailReponse"
                            [postTooltip]="'admin.bibliotheque.notifications.envoiMails.tooltip.mailReponse' | translate">
                    </custom-input>
                    <!--E-mail licence-->
                    <custom-input
                            ngDefaultControl
                            customType="input"
                            [(ngModel)]="configSMTP.mailLicence"
                            name="mailLicence"
                            libelle="admin.bibliotheque.notifications.envoiMails.mailLicence"
                            [postTooltip]="'admin.bibliotheque.notifications.envoiMails.tooltip.mailLicence' | translate">
                    </custom-input>
                </div>
            </mat-card-content>
        </mat-card>

        <!--Bouton flottant de sauvegarde-->
        <floating-button [listeActions]="listeActions" [isPending]="notificationMailsService.isSaving"></floating-button>
    </div>
</form>

<!--Affiché pendant le chargement-->
<ng-template #loading>
    <please-wait class="content"></please-wait>
</ng-template>
